import {
    authAction,
    BACKEND_CLIENT_VERSION,
    IS_NEW_BACKEND_CLIENT_VERSION,
    REDUX_CLEAR_STORAGE,
    REDUX_CLOSE_MODAL,
    REDUX_MEMBER_LIST_COLUMNS,
    REDUX_OPEN_MODAL,
    UPDATE_RESULT_STATUS,
} from 'common/constants';

export const setToken = token => ({
    type: authAction.SET_TOKEN,
    payload: token,
});

export const getUser = userInfo => ({
    type: authAction.GET_USER,
    payload: userInfo,
});
export const deleteToken = token => ({
    type: authAction.DELETE_TOKEN,
    payload: token,
});

export const setEnableFeatures = payload => ({
    type: authAction.SET_ENABLE_FEATURES,
    payload
});
export const deleteEnableFeatures = payload => ({
    type: authAction.DELETE_ENABLE_FEATURES,
    payload
});

export const updateResultStatus = status => ({
    type: UPDATE_RESULT_STATUS,
    payload: status
});

export const getBackenClientVersion = payload => ({
    type: BACKEND_CLIENT_VERSION,
    payload
});

export const onReloadPage = (boolean) => ({
    type: IS_NEW_BACKEND_CLIENT_VERSION,
    payload: boolean
});

export const openModal = (id, props = {}) => ({
    type: REDUX_OPEN_MODAL,
    payload: { id, props },
});

export const closeModal = (id, props = {}) => ({
    type: REDUX_CLOSE_MODAL,
    payload: { id, props },
});

export const updateMemberListVisibleColumns = (memberListVisibleColumns) => ({
    type: REDUX_MEMBER_LIST_COLUMNS,
    payload: memberListVisibleColumns,
});

export const clearReduxStore = () => ({
    type: REDUX_CLEAR_STORAGE,
    payload: null,
});
